/**
 * Handles:
 * - Header hide/show on scroll
 * - Scroll-to-top button
 * - Share button toggle
 */

export function initScrollInteractions() {
    const header = document.querySelector('#header');
    if (!header) return;

    const body = document.body;
    const share = document.querySelector('#share');
    const stickyTop = document.querySelector('#sticky .option.top');
    const stickyShare = document.querySelector('#sticky .option.share');
    const mainNav = document.querySelector('#mainnav');
    const search = document.querySelector('#search');
    const headerOptions = document.querySelector('#headeroptions');

    let lastScrollTop = 0;
    const winWidth = () => window.innerWidth;

    /* --------------------------------------------
     * Scroll behavior
     * -------------------------------------------- */
    window.addEventListener('scroll', () => {
        const scrollTop = window.scrollY;
        toggleHeader(scrollTop);
        lastScrollTop = scrollTop;
    });

    /* --------------------------------------------
     * Scroll-to-top button
     * -------------------------------------------- */
    if (stickyTop) {
        stickyTop.addEventListener('click', e => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }

    /* --------------------------------------------
     * Share toggle button
     * -------------------------------------------- */
    if (stickyShare) {
        stickyShare.addEventListener('click', toggleShare);
    }

    function toggleHeader(scrollTop) {
        const largeScreen = winWidth() >= 992;
        const selector = largeScreen ? '#header, #autozoeker' : '#header';
        const headerTargets = document.querySelectorAll(selector);

        if (scrollTop > 100) {
            headerTargets.forEach(el => {
                if (scrollTop < lastScrollTop) {
                    el.classList.remove('hide');
                } else {
                    el.classList.add('hide');
                }
            });
            share?.classList.add('show');
        } else {
            headerTargets.forEach(el => el.classList.remove('hide'));
            share?.classList.remove('show');
        }
    }

    function toggleShare() {
        const isActive = share?.classList.contains('active');

        // Reset other UI states
        mainNav?.classList.remove('active');
        search?.classList.remove('active');

        if (headerOptions) {
            headerOptions.querySelectorAll('.option.menu, .option.search')
                .forEach(btn => btn.classList.remove('active'));
        }

        // Toggle share panel
        share?.classList.toggle('active', !isActive);
        stickyShare.classList.toggle('active', !isActive);

        // Remove focus from search input if visible
        const searchInput = search?.querySelector('input');
        if (searchInput) searchInput.blur();
    }
}
